import styled, { css } from 'styled-components';

// @ts-ignore
type TSLogoProps = InferProps<typeof Logo.propTypes>

const Logo = styled.i<TSLogoProps>`
  ${({ $withMask }) => $withMask ? css`
    mask: url("/img/logo.svg") no-repeat center;
    -webkit-mask: url("/img/logo.svg") no-repeat center;
    background-color: currentColor;
    mask-size: contain;
    -webkit-mask-size: contain;
  ` : `
    background: url("/img/logo.svg") no-repeat center;
    background-size: contain;
  `}
  display: inline-block;
  min-width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export default Logo;
